import React from "react";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EditDocumentIcon from "@mui/icons-material/EditDocument";
import AssessmentIcon from "@mui/icons-material/Assessment";
import WorkflowCard from "./WorkflowCard";
import "./workflow.css";

const Workflow = () => {
  const workflowSteps = [
    {
      icon: AccountCircleIcon,
      heading: "1. Create an account",
      copy: "Registration & Login",
    },
    {
      icon: EditDocumentIcon,
      heading: "2. Fill out the questionnaire",
      copy: "Answer some short questions about your organization and data processes",
    },
    {
      icon: AssessmentIcon,
      heading: "3. Receive results and take action",
      copy: "Assess your digital maturity on your dashboard and use tips and templates to improve",
    },
  ];

  return (
    <section className="workflow">
      <div className="workflow__inner">
        <div className="workflow__header">
          <span className="workflow__eyebrow">
            GUIDE IN THREE EASY STEPS
          </span>
          <h2 className="workflow__title">How does the tool work?</h2>
        </div>
        <div className="workflow__grid">
          {workflowSteps.map((step, index) => (
            <WorkflowCard
              key={index}
              icon={step.icon}
              heading={step.heading}
              copy={step.copy}
            />
          ))}
        </div>
        <div className="workflow__footer">
          <div className="workflow__footer-icon" aria-hidden="true">
            <LocalFloristIcon fontSize="inherit" />
          </div>
          <h3 className="workflow__footer-title">Staying sustainable</h3>
          <p className="workflow__footer-copy">
            Use continuous improvement methods to strenghten your data governance over the long term
          </p>
        </div>
      </div>
    </section>
  );
};

export default Workflow;
